import {
  isExist,
  floatAdd,
  floatMulSub,
  floatMulAdd,
} from '@qx/utils/index';

// 计算单价
export const fnCalCostPrice = (_this) => {
  const customerForm = _this.$refs.customerForm;
  const incomeForm = _this.$refs.incomeForm;
  const carriageForm = _this.$refs.carriageForm;

  let priceEnum = Number(incomeForm.otherFormData.priceEnum);
  if (!isExist(priceEnum)) {
    priceEnum = 1;
    incomeForm.otherFormData.priceEnum = '1';
  }
  // 获取当前输入的单价
  let priceUnit = incomeForm.$refs.baseForm.getVal('priceUnit');

  if (!isExist(priceUnit) || isNaN(priceUnit)) {
    priceUnit = 0;
  }

  // 数量
  let num = 0;
  if (priceEnum === 1) {
    // 按车计算
    num = 1;
  } else if (priceEnum === 2) {
    // 按千克计算（获取当前输入的重量）
    num = Number(carriageForm.kilogram);
  } else if (priceEnum === 3) {
    // 按方计算（获取当前输入的体积）
    num = carriageForm.otherFormData.square;
  } else if (priceEnum === 4) {
    // 按公里计算（获取当前输入的客户公里数）
    num = customerForm.$refs.baseForm.getVal('cmMileageNumber');
  } else if (priceEnum === 5) {
    // 按件计算（获取当前输入的计划数量）
    num = carriageForm.$refs.baseForm.getVal('goodsNumber');
  } else if (priceEnum === 6) {
    // 按吨计算 （获取当前输入的吨）
    num = Number(carriageForm.otherFormData.weight);
  }

  if (!isExist(num) || isNaN(num)) {
    num = 0;
  }

  const preCostPrice = incomeForm.$refs.baseForm.getVal('costPrice');
  const costPrice = (priceUnit * num).toFixed(2);
  incomeForm.$refs.baseForm.setVal('costPrice', costPrice);
  if (Number(preCostPrice) !== Number(costPrice)) {
    fnCalPreAndFinalFee(_this, 1);
  }
};
// 计算预付和尾款，changeType=1 重新计算；（抄原来的）
export const fnCalPreAndFinalFee = (_this, changeType) => {
  const incomeForm = _this.$refs.incomeForm;
  let costPrice = incomeForm.$refs.baseForm.getVal('costPrice');
  if (!isExist(costPrice) || isNaN(costPrice)) {
    costPrice = 0;
  }
  let prePayCash = incomeForm.$refs.baseForm.getVal('prePayCash');
  if (!isExist(prePayCash) || isNaN(prePayCash) || changeType === 1) {
    // 预付全款
    if (Number(incomeForm.balanceData.balanceType) === 1) {
      prePayCash = costPrice;
    } else {
      prePayCash = 0;
    }
    incomeForm.$refs.baseForm.setVal('prePayCash', prePayCash);
    incomeForm.$refs.baseForm.setVal('prePayEquivalenceCardAmount', 0);
    incomeForm.$refs.baseForm.setVal('afterPayCash', Number(costPrice) - Number(prePayCash));
  }
  let prePayEquivalenceCardAmount = incomeForm.$refs.baseForm.getVal('prePayEquivalenceCardAmount');
  if (!isExist(prePayEquivalenceCardAmount) || isNaN(prePayEquivalenceCardAmount)) {
    incomeForm.$refs.baseForm.setVal('prePayEquivalenceCardAmount', 0);
  }
  let afterPayCash = incomeForm.$refs.baseForm.getVal('afterPayCash');
  if (!isExist(afterPayCash) || isNaN(afterPayCash) || changeType === 1) {
    if (Number(incomeForm.balanceData.balanceType) !== 1) {
      afterPayCash = costPrice;
    } else {
      afterPayCash = 0;
    }
  }
  incomeForm.$refs.baseForm.setVal('afterPayCash', afterPayCash);
  let afterPayEquivalenceCardAmount = incomeForm.$refs.baseForm.getVal('afterPayEquivalenceCardAmount');
  if (!isExist(afterPayEquivalenceCardAmount) || isNaN(afterPayEquivalenceCardAmount)) {
    incomeForm.$refs.baseForm.setVal('afterPayEquivalenceCardAmount', 0);
  }
};
// 改变预付现金（抄原来的）
export const fnChangePrePayCash = (_this) => {
  const incomeForm = _this.$refs.incomeForm;

  let costPrice = Number(incomeForm.$refs.baseForm.getVal('costPrice'));
  if (!isExist(costPrice) || isNaN(costPrice) || costPrice < 0) {
    costPrice = 0;
    incomeForm.$refs.baseForm.setVal('costPrice', 0);
  }
  let prePayCash = Number(incomeForm.$refs.baseForm.getVal('prePayCash'));
  if (!isExist(prePayCash) || isNaN(prePayCash) || prePayCash < 0) {
    prePayCash = 0;
    incomeForm.$refs.baseForm.setVal('prePayCash', 0);
  }
  if (costPrice < prePayCash) {
    incomeForm.$refs.baseForm.setVal('prePayCash', 0);
    _this.$message({
      type: 'info',
      message: '预付现金不能大于收入！',
    });
    return;
  }

  let prePayEquivalenceCardAmount = Number(incomeForm.$refs.baseForm.getVal('prePayEquivalenceCardAmount'));
  if (!isExist(prePayEquivalenceCardAmount) || isNaN(prePayEquivalenceCardAmount) || prePayEquivalenceCardAmount < 0 || prePayCash >= costPrice) {
    prePayEquivalenceCardAmount = 0;
    incomeForm.$refs.baseForm.setVal('prePayEquivalenceCardAmount', 0);
  }

  if (costPrice < (floatAdd(prePayCash, prePayEquivalenceCardAmount))) {
    incomeForm.$refs.baseForm.setVal('prePayEquivalenceCardAmount', 0);
    _this.$message({
      type: 'info',
      message: '预付现金加预付等值卡金额不能大于收入！',
    });
    return;
  }
  const afterPayCash = floatMulSub(costPrice, [prePayCash, prePayEquivalenceCardAmount]);
  incomeForm.$refs.baseForm.setVal('afterPayCash', afterPayCash);
  incomeForm.$refs.baseForm.setVal('afterPayEquivalenceCardAmount', 0);
};
// 改变尾款现金（抄原来的）
export const fnChangeAfterPayCash = (_this) => {
  const incomeForm = _this.$refs.incomeForm;

  let costPrice = Number(incomeForm.$refs.baseForm.getVal('costPrice'));
  if (!isExist(costPrice) || isNaN(costPrice) || costPrice < 0) {
    costPrice = 0;
    incomeForm.$refs.baseForm.setVal('costPrice', 0);
  }
  let prePayCash = Number(incomeForm.$refs.baseForm.getVal('prePayCash'));
  if (!isExist(prePayCash) || isNaN(prePayCash) || prePayCash < 0) {
    prePayCash = 0;
    incomeForm.$refs.baseForm.setVal('prePayCash', 0);
  }
  let prePayEquivalenceCardAmount = Number(incomeForm.$refs.baseForm.getVal('prePayEquivalenceCardAmount'));
  if (!isExist(prePayEquivalenceCardAmount) || isNaN(prePayEquivalenceCardAmount) || prePayEquivalenceCardAmount < 0 || prePayCash >= costPrice) {
    prePayEquivalenceCardAmount = 0;
    incomeForm.$refs.baseForm.setVal('prePayEquivalenceCardAmount', 0);
  }
  let afterPayCash = Number(incomeForm.$refs.baseForm.getVal('afterPayCash'));
  if (!isExist(afterPayCash) || isNaN(afterPayCash) || afterPayCash < 0) {
    afterPayCash = 0;
    incomeForm.$refs.baseForm.setVal('afterPayCash', 0);
  }
  if (costPrice < (floatMulAdd([prePayCash, prePayEquivalenceCardAmount, afterPayCash]))) {
    incomeForm.$refs.baseForm.setVal('afterPayCash', 0);
    _this.$message({
      type: 'info',
      message: '预付现金加预付等值卡金额加尾款现金不能大于收入！',
    });
    return;
  }
  const afterPayEquivalenceCardAmount = floatMulSub(costPrice, [prePayCash, prePayEquivalenceCardAmount, afterPayCash]);
  incomeForm.$refs.baseForm.setVal('afterPayEquivalenceCardAmount', afterPayEquivalenceCardAmount);
};
// 改变预付等值卡额（抄原来的）
export const fnChangePrePayEquivalenceCardAmount = (_this) => {
  const incomeForm = _this.$refs.incomeForm;

  let costPrice = Number(incomeForm.$refs.baseForm.getVal('costPrice'));
  if (!isExist(costPrice) || isNaN(costPrice) || costPrice < 0) {
    costPrice = 0;
    incomeForm.$refs.baseForm.setVal('costPrice', 0);
  }
  let prePayCash = Number(incomeForm.$refs.baseForm.getVal('prePayCash'));
  if (!isExist(prePayCash) || isNaN(prePayCash) || prePayCash < 0) {
    prePayCash = 0;
    incomeForm.$refs.baseForm.setVal('prePayCash', 0);
  }
  let prePayEquivalenceCardAmount = Number(incomeForm.$refs.baseForm.getVal('prePayEquivalenceCardAmount'));
  if (!isExist(prePayEquivalenceCardAmount) || isNaN(prePayEquivalenceCardAmount) || prePayEquivalenceCardAmount < 0 || prePayCash >= costPrice) {
    prePayEquivalenceCardAmount = 0;
    incomeForm.$refs.baseForm.setVal('prePayEquivalenceCardAmount', 0);
  }
  if (costPrice < (floatAdd(prePayCash, prePayEquivalenceCardAmount))) {
    incomeForm.$refs.baseForm.setVal('prePayEquivalenceCardAmount', 0);
    _this.$message({
      type: 'info',
      message: '预付现金加预付等值卡金额不能大于收入！',
    });
    return;
  }

  const afterPayCash = floatMulSub(costPrice, [prePayCash, prePayEquivalenceCardAmount]);
  incomeForm.$refs.baseForm.setVal('afterPayCash', afterPayCash);
  incomeForm.$refs.baseForm.setVal('afterPayEquivalenceCardAmount', 0);
};
/* eslint-disable */
// 改变尾款等值卡额（抄原来的）
export const fnChangeAfterPayEquivalenceCardAmount = (_this) => {
  const incomeForm = _this.$refs.incomeForm;

  let costPrice = Number(incomeForm.$refs.baseForm.getVal('costPrice'));
  if (!isExist(costPrice) || isNaN(costPrice) || costPrice < 0) {
    costPrice = 0;
    incomeForm.$refs.baseForm.setVal('costPrice', 0);
  }
  let prePayCash = Number(incomeForm.$refs.baseForm.getVal('prePayCash'));
  if (!isExist(prePayCash) || isNaN(prePayCash) || prePayCash < 0) {
    prePayCash = 0;
    incomeForm.$refs.baseForm.setVal('prePayCash', 0);
  }
  let prePayEquivalenceCardAmount = Number(incomeForm.$refs.baseForm.getVal('prePayEquivalenceCardAmount'));
  if (!isExist(prePayEquivalenceCardAmount) || isNaN(prePayEquivalenceCardAmount) || prePayEquivalenceCardAmount < 0) {
    prePayEquivalenceCardAmount = 0;
    incomeForm.$refs.baseForm.setVal('prePayEquivalenceCardAmount', 0);
  }
  let afterPayCash = Number(incomeForm.$refs.baseForm.getVal('afterPayCash'));
  if (!isExist(afterPayCash) || isNaN(afterPayCash) || afterPayCash < 0) {
    afterPayCash = 0;
    incomeForm.$refs.baseForm.setVal('afterPayCash', 0);
  }
  let afterPayEquivalenceCardAmount = Number(incomeForm.$refs.baseForm.getVal('afterPayEquivalenceCardAmount'));
  if (!isExist(afterPayEquivalenceCardAmount) || isNaN(afterPayEquivalenceCardAmount) || afterPayEquivalenceCardAmount < 0) {
    afterPayEquivalenceCardAmount = 0;
    incomeForm.$refs.baseForm.setVal('afterPayEquivalenceCardAmount', 0);
  }
  if (costPrice < floatMulAdd([prePayCash, prePayEquivalenceCardAmount, afterPayCash, afterPayEquivalenceCardAmount])) {
    const afterPayEquivalenceCardAmount = floatMulSub(costPrice, [prePayCash, prePayEquivalenceCardAmount, afterPayCash]);
    incomeForm.$refs.baseForm.setVal('afterPayEquivalenceCardAmount', afterPayEquivalenceCardAmount);
    _this.$message({
      type: 'info',
      message: '预付加尾款不能大于收入！',
    });
    return;
  }
  incomeForm.$refs.baseForm.setVal('afterPayCash', floatMulSub(costPrice, [prePayCash, prePayEquivalenceCardAmount, afterPayEquivalenceCardAmount]));
};
